import { useCreateHandbookContext } from "./CreateHandbookContext";
import AddButton from "shared/ui/controls/AddButton/AddButton";

import styles from "./CreateHandbookTemplate.module.scss";

interface CreateHandbookTemplateBtnProps {
  text: string;
}

const CreateHandbookTemplateBtn: React.FC<CreateHandbookTemplateBtnProps> = ({ text = "" }) => {
  const { setIsSectionCreating, isSectionCreating } = useCreateHandbookContext();

  return (
    <AddButton
      variant="solid"
      small
      text={text}
      textPosition="left"
      onClick={() => setIsSectionCreating(true)}
      className={styles.addButton}
      isDisabled={isSectionCreating}
    />
  );
};

export default CreateHandbookTemplateBtn;
